import { AnyAction } from "redux";
import { ParsedRecord } from "../../types/airtable";

// Action Definitions
export interface HoverPeak {
  type: "HOVER_PEAK";
  payload: string | null;
}
export interface ClickPeak {
  type: "CLICK_PEAK";
  payload: string;
}
export interface SetZoomPeak {
  type: "SET_ZOOM_PEAK";
  payload: string | null;
}
export interface HoverImage {
  type: "HOVER_IMAGE";
  payload: string | null;
}

// Union Action Types
export type Action = HoverPeak | ClickPeak | SetZoomPeak | HoverImage;

// Action Creators
export const hoverPeak = (peakId: string | null): HoverPeak => {
  //   console.log(`Hovered on card ${peakId}`);
  return { type: "HOVER_PEAK", payload: peakId };
};
export const clickPeak = (peakId: string): ClickPeak => {
  console.log(`Clicked on peak ${peakId}`);
  return { type: "CLICK_PEAK", payload: peakId };
};
export const setZoomPeak = (peakId: string | null): SetZoomPeak => {
  console.log(`Set zoom peak to ${peakId}`);
  return { type: "SET_ZOOM_PEAK", payload: peakId };
};
export const hoverImage = (imageId: string | null): HoverImage => {
  return { type: "HOVER_IMAGE", payload: imageId };
};
